import React, { useState } from "react";

import pushToAnalytics from "../../../../../utils/analytics";
import { storageLocal as storage } from "../../../../../utils/StorageHandler";
import AmountInput from "../../../../pages/HeatingOil/CalculatorPage/Calculator/AmountInput";
import ZipcodeInput from "../../../../pages/HeatingOil/CalculatorPage/Calculator/ZipcodeInput";
import useCalulatorStore from "../../../../pages/HeatingOil/CalculatorPage/store";
import NewInput from "../../../forms/NewInput";
import Button from "../../../NewForms/Button";
import { useNavigate } from "../provider";
import {
    ActionRow,
    FormContainer,
    FormRow,
    InputWrapper,
} from "../styledComponents";

const HeatingOilCalculator = () => {
    const [zipcode, amount, up, setZipcode, setAmount, setUp] =
        useCalulatorStore((state) => [
            state.zipcode,
            state.amount,
            state.up,
            state.setZipcode,
            state.setAmount,
            state.setUp,
        ]);

    const [zipcodeError, setZipcodeError] = useState(false);
    const [amountError, setAmountError] = useState(false);
    const [upError, setUpError] = useState(false);

    const onChangeAmount = (event) => {
        setAmount(event.target.value);
    };

    const navigate = useNavigate("/heizoel");

    const handleClick = () => {
        if (
            zipcode &&
            !zipcodeError &&
            amount &&
            !amountError &&
            up &&
            !upError
        ) {
            storage.set("hel:zipcode", zipcode);
            storage.set("hel:amount", amount);
            storage.set("hel:up", up);
            pushToAnalytics("hel:calculate", {
                zipcode: zipcode,
                amount: amount,
                up: up,
                dataGtag: "hel-calculate-default",
            });
            setTimeout(() => navigate(), 0);
        } else if (!up) {
            setUpError(true);
        }
    };

    return (
        <FormContainer>
            <FormRow>
                <InputWrapper>
                    <ZipcodeInput
                        setZipcode={setZipcode}
                        localZipcode={zipcode}
                        zipcodeError={zipcodeError}
                        setZipcodeError={setZipcodeError}
                        skipAvailabilityValidation
                    />
                </InputWrapper>
                <InputWrapper>
                    <AmountInput
                        localAmount={amount}
                        setAmountError={setAmountError}
                        onChangeAmount={onChangeAmount}
                        zipcodeError={zipcodeError}
                        amountError={amountError}
                        localZipcode={zipcode}
                    />
                </InputWrapper>
                <InputWrapper>
                    <NewInput
                        name="unloading_points"
                        placeholder="Haushalte"
                        value={up}
                        onChange={(e) => setUp(e.target.value)}
                        validation="hel:up"
                        onError={() => setUpError(true)}
                        onErrorSolved={() => setUpError(false)}
                        forceError={upError}
                    />
                </InputWrapper>
            </FormRow>
            <ActionRow>
                <Button onClick={handleClick} data-gtag="hel-calculate-default">
                    Preis berechnen
                </Button>
            </ActionRow>
        </FormContainer>
    );
};

const WithProvider = () => {
    return <HeatingOilCalculator />;
};

export default WithProvider;
